<template>
  <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px" size="medium">
    <input type="password" class="hide" v-show='false' id="loginPassword"/>
    <input type="text" class="hide" v-show='false' id="loginUserName"/>
    <el-form-item label="账号名称" prop="userAccount">
      {{formData.userAccount}}
    </el-form-item>
    <el-form-item label="当前密码" prop="oldPsw">
      <el-input type="password" v-model="formData.oldPsw" ></el-input>
    </el-form-item>
    <el-form-item label="新的密码" prop='newPsw'>
      <el-input type="password" v-model="formData.newPsw" ></el-input>
    </el-form-item>
    <el-form-item label="确认新密码" prop="checkNewPsd">
      <el-input type="password" v-model="formData.checkNewPsd" placeholder="请再次输入新密码"></el-input>
    </el-form-item>
    <el-form-item class="standard-form-bottom">
      <el-button v-on:click="closeDialog">取消</el-button>
      <el-button type="primary" v-on:click="saveRole">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {Message} from 'element-ui'
import md5 from 'js-md5';

export default {
  name: "PwdDialog",
  props: ['username'],
  created() {
    this.initData();
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formData.checkNewPsd !== '') {
          this.$refs.ruleForm.validateField('checkNewPsd')
        }
        callback()
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.newPsw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    };
    return {
      formData: {
        userAccount: '',
        oldPsw: '',
        newPsw: '',
        checkNewPsd: ''
      },
      rules: {
        oldPsw: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPsw: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass }
        ],
        checkNewPsd: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePass2 }
        ]
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', this.formData);
    },
    initData() {
      this.formData.userAccount = this.username
      this.resetForm('ruleForm')
    },
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    saveRole() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {};
          let oldpwd = this.formData.oldPsw
          let newpwd = this.formData.newPsw
          params = {
            "userAccount": this.formData.userAccount,
            "oldPsw": md5(oldpwd),
            "newPsw": md5(newpwd)
          };
          this.$api.systemManage.changePsw(params).then(res => {
            if(res.code === 200) {
              this.$emit('closeDialog');
              Message.success(res.message)
            }else {
              Message.warning(res.message)
            }
          })
        }else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
  .tree-container{
    overflow-y: auto;
    width: 528px;
    height: 260px;
    border: 1px solid #D2D2D2;
  }
  .hide{
    width: 0;
    position: absolute
  }
  .standard-form-bottom{
    width: 100%;
    text-align: right
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/PwdDialog.vue